import {
  DASH_LABELS,
  DASH_TYPES,
  OVCPL,
  DASH_TYPE_GROUPS,
} from './dashConstants'

export const META_BY_LOCATION_DETAIL = {
  OVCPL: {
    label: DASH_LABELS.UPPER_PANEL_CENTER,
    partOverride: 'M2_OVCPL_HALF',
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
}

export const DASH_META = {
  name: DASH_TYPES.OVERHEAD_35M_003,
  type: DASH_TYPE_GROUPS.OVERHEAD,
  panels: [OVCPL],
  width: 1000,
  height: 200,
}

export const FALLBACK_COMPONENTS_BY_DETAIL = {
  C: 'Switch',
}

export default {
  ...DASH_META,
  ...META_BY_LOCATION_DETAIL,
  fallbacks: FALLBACK_COMPONENTS_BY_DETAIL,
  lists: {
    OVCPL: {
      id: OVCPL,
      label: DASH_LABELS.UPPER_PANEL_CENTER,
      groups: {
        OVCPL: {
          id: OVCPL,
          panel: OVCPL,
          isMsfOrMst: true,
          parent: [OVCPL],
          label: DASH_LABELS.UPPER_PANEL_CENTER,
          detail: ['C'],
        },
      },
    },
  },
}
